<div [formGroup]="form" class="row row-cols-sm-auto">
  <div class="col-12">
    <div class="dp-hidden position-absolute">
      <div class="input-group">
        <input name="datepicker" ngbDatepicker #datepicker="ngbDatepicker" [autoClose]="'outside'" (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1" [footerTemplate]="footerTemplate" [minDate]="minDate" [maxDate]="maxDate" class="form-control" />
        <ng-template #t let-date let-focused="focused" let-disabled="disabled">
          <span class="custom-day" [class.disabled]="disabled" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>
        <ng-template #footerTemplate>
          <hr class="my-0" />
          <div *ngIf="firstBtnRowEnabled" class="row custom-button-row justify-content-center mt-2 ms-md-2">
            <div *ngIf="btnTodayEnabled" class="col-3 text-center pe-md-1 ps-md-2 ">
              <button class="btn btn-primary custom-date-selection-button col-12" (click)="setPresetDate(datepicker, 0)">{{ 'common.datePicker.today' | translate }}</button>
            </div>
            <div *ngIf="btnYesterdayEnabled" class="col-3 text-center pe-md-1 ps-md-2">
              <button class="btn btn-primary custom-date-selection-button col-12" (click)="setPresetDate(datepicker, 1)">{{ 'common.datePicker.yesterday' | translate }}</button>
            </div>
            <div *ngIf="btnThisWeekEnabled" class="col-3 text-center pe-md-1 ps-md-2">
              <button class="btn btn-primary custom-date-selection-button col-12" (click)="setPresetDate(datepicker, 2)">{{ 'common.datePicker.thisWeek' | translate }}</button>
            </div>
            <div *ngIf="btnLastWeekEnabled" class="col-3 text-center pe-md-1 ps-md-2">
              <button class="btn btn-primary custom-date-selection-button col-12" (click)="setPresetDate(datepicker, 3)">{{ 'common.datePicker.lastWeek' | translate }}</button>
            </div>
          </div>
          <div *ngIf="secondBtnRowEnabled" class="row custom-button-row justify-content-center mt-2 ms-md-2">
            <div *ngIf="btnThisMonthEnabled" class="col-4 text-center pe-md-1 ps-md-2">
              <button class="btn btn-primary custom-date-selection-button col-12" (click)="setPresetDate(datepicker, 4)">{{ 'common.datePicker.thisMonth' | translate }}</button>
            </div>
            <div *ngIf="btnLastMonthEnabled" class="col-4 text-center pe-md-1 ps-md-2">
              <button class="btn btn-primary custom-date-selection-button col-12" (click)="setPresetDate(datepicker, 5)">{{ 'common.datePicker.lastMonth' | translate }}</button>
            </div>
            <div *ngIf="btnLastQuarterEnabled" class="col-4 text-center pe-md-1 ps-md-2">
              <button class="btn btn-primary custom-date-selection-button col-12"  (click)="setPresetDate(datepicker, 6)">{{ 'common.datePicker.lastQuarter' | translate }}</button>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="text-center col-12 col-md-2">
              <button class="btn btn-outline-secondary btn-sm m-2 float-end col-12" (click)="close(datepicker)">{{ 'common.datePicker.close' | translate }}</button>
            </div>
            <div class="text-center col-12 col-md-2">
              <button class="btn btn-outline-secondary btn-sm m-2 float-end col-12" (click)="reset()">{{ 'common.datePicker.reset' | translate }}</button>
            </div>
            <div class=" text-center col-12 col-md-2">
              <button class="btn btn-primary btn-sm m-2 float-end col-12" (click)="apply(datepicker)">{{ 'common.datePicker.apply' | translate }}</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="input-group">
    <input (click)="datepicker.toggle()" class="form-control" placeholder="yyyy-mm-dd" name="dpFromDate" [value]="formatDates()" readonly />
  </div>
</div>
